import { Pipe, PipeTransform } from '@angular/core';
import { FilterPipe } from './filter.pipe';

@Pipe({
  name: 'checkChildren'
})
export class CheckChildrenPipe implements PipeTransform {

  constructor(private filterPipe: FilterPipe) { }

  // Devuelve los elementos de un array cuya propiedad children no sea un array vacío tras filtrar con el pipe filter
  transform(list: any, children: string, property: string, operator: string, filter: string, chars?: number): any[] {
    return list.filter(item => this.filterPipe.transform(item[children], property, operator, filter, chars).length);
  }

}
